import { render } from "./SensorIcon.vue?vue&type=template&id=2221a098&scoped=true&ts=true"
import script from "./SensorIcon.vue?vue&type=script&lang=ts"
export * from "./SensorIcon.vue?vue&type=script&lang=ts"

import "./SensorIcon.vue?vue&type=style&index=0&id=2221a098&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2221a098"]])

export default __exports__